import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postOptimizelyExperiments } from '../api/api';

const fetchExperiments = createAsyncThunk(
  'experiments/fetchExperiments', async (userId) => {
    const payload = userId
      ? { track_user_id: true, user_attributes: { platform: 'web', user_id: userId } }
      : { track_user_id: false, user_attributes: { platform: 'web' } };
    const response = await postOptimizelyExperiments(payload);
    return response;
  }
);

const defaultState = { loaded: false };

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState: defaultState,
  reducers: {
    resetExperiments: () => defaultState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExperiments.fulfilled, (state, action) => {
      const experiments = action.payload;
      const result = { loaded: true };
      experiments.forEach((experiment) => {
        result[experiment.flag_key] = experiment;
      });
      return result;
    });
    builder.addCase(fetchExperiments.rejected, (state) => {
      state.loaded = true;
    });
  },
});

export { fetchExperiments };
export const { resetExperiments } = experimentsSlice.actions;
export default experimentsSlice.reducer;
